<template lang="html">
  <footer id="footer">
    <div class="container">
      <div class="row">
        <div class="col-12 col-footer col-logo">
          <router-link to="/">
            <img src="/public/images/logo-white.svg">
          </router-link>
        </div>

        <div class="col-12 col-footer col-contact">
          <span class="tel"><i class="fas fa-phone-alt icon"></i> (+506) 4001-5353</span>
          <a class="email" href="mailto:info@sircostarica.com"><i class="fas fa-envelope icon"></i> info@sircostarica.com</a>

          <span class="networks">
            <a target="_blank" href="https://www.facebook.com/CostaRicaSothebysRealty/?fref=ts"><i class="fab fa-facebook-f"></i></a>
            <a target="_blank" href="https://www.instagram.com/costaricasothebysrealty/"><i class="fab fa-instagram"></i></a>
            <a target="_blank" href="https://www.linkedin.com/company/costa-rica-sotheby's-international-realty/"><i class="fab fa-linkedin-in"></i></a>
            <a target="_blank" href="https://www.youtube.com/user/SIRCostaRica"><i class="fab fa-youtube"></i></a>
            <!-- <a target="_blank" href="https://x.com/SIR_CostaRica"><i class="fab fa-twitter"></i></a> -->
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-6 col-lg-3 col-footer col-links">
          <h6 class="title">{{ $t("footer.properties") }}</h6>

          <router-link to="/properties">{{ $t("footer.all_listing") }}</router-link><br />
          <router-link to="/properties/rent">{{ $t("footer.reting") }}</router-link><br />
          <router-link to="/properties/sale">{{ $t("footer.selling") }}</router-link><br />
        </div>

        <div class="col-6 col-lg-3 col-footer col-links">
          <h6 class="title">{{ $t("footer.discover") }}</h6>

          <router-link to="/destinations">{{ $t("footer.destinations") }}</router-link><br />
          <router-link to="/lifestyles">{{ $t("footer.lifestyle") }}</router-link><br />
          <router-link to="/projects">{{ $t("footer.projects") }}</router-link>
        </div>

        <div class="col-6 col-lg-3 col-footer col-links">
          <h6 class="title">{{ $t("footer.about_us") }}</h6>

          <router-link to="/sell-with-us">{{ $t("footer.selling_a_home") }}</router-link><br />
          <router-link to="/about-sothebys-costa-rica">{{ $t("footer.about_sothebys_mexico") }}</router-link><br>
          <router-link to="/privacy-policy">{{ $t("footer.privacy_policy") }}</router-link><br>
          <router-link to="/terms">{{ $t("footer.terms") }}</router-link><br>
        </div>

        <div class="col-6 col-lg-3 col-footer col-links">
          <h6 class="title">{{ $t("footer.more_links") }}</h6>

          <router-link to="/agents">{{ $t("footer.agents") }}</router-link><br />
          <router-link to="/contact">{{ $t("footer.contact_us") }}</router-link><br />
          <router-link to="/blog">{{ $t("footer.our_blog") }}</router-link>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
}
</script>
